var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row flex gap-2 mt-5"},[_c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":"success"}},[_c('span',[_vm._v("in")])]),(_vm.params.data.sparepart_out != null)?_c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":"danger"}},[_c('span',[_vm._v("out")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }